import { render, staticRenderFns } from "./TopBoard.vue?vue&type=template&id=37dc59c9"
import script from "./TopBoard.vue?vue&type=script&lang=js"
export * from "./TopBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports